import React, {useEffect, useRef, useState} from 'react';
import classNames from "classnames";


import './Textarea.css';


export interface TextareaProps {
    value: string;
    className?: string;
    placeholder?: string;
    onChange?: (newValue: string) => void;
    disabled?: boolean;
    fixedHeight?: number;
    withBorder?: boolean;
    minHeight?: number;
}


export const Textarea = (
    {
        value,
        className,
        onChange,
        placeholder,
        disabled,
        fixedHeight,
        minHeight,
        withBorder,
    }: TextareaProps
) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [isFocused, setIsFocused] = useState(false);


    useEffect(() => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight + (isFocused ? 4 : 0)}px`;
        }
        if (fixedHeight !== null) {
            textAreaRef.current!.style.maxHeight = `${fixedHeight}px`;
        }
        if (minHeight !== null) {
            textAreaRef.current!.style.minHeight = `${minHeight}px`;
        }
    }, [value]);

    return (
        <textarea
            className={
                classNames({
                    "Textarea body-large": true,
                    "Textarea__withBorder": withBorder,
                    "Textarea--disabled": disabled,
                    "Textarea--isFocused": isFocused,
                    [className!]: className,
                })
            }
            onChange={(event) => {
                onChange && onChange(event.target.value);
            }}
            disabled={disabled}
            value={value}
            placeholder={placeholder}
            ref={textAreaRef}
            onFocus={() => {
                setIsFocused(true);
            }}
            onBlur={() => {
                setIsFocused(false);
            }}
        />
    )
}
